import React from 'react'

const NotAllowed = React.memo(
    function NotAllowed() {
        return <div className='d-flex justify-content-center align-self-center'>Não Tem as Permissões Necessárias Para Aceder a Esta Página</div>
    }
)

export default NotAllowed
